import React,{useEffect} from "react";
import AOS from "aos";
import "aos/dist/aos.css"; 

function OurServices() {
  useEffect(() => {
      AOS.init({
        duration: 1000, // Animation duration in milliseconds
        once: true, // Animation happens only once
      });
    }, []);
  return (
    <div>
     {/* Services Section */}
    <section id="services" class="services section light-background">

     {/* Section Title */}
      <div class="container section-title" 
      data-aos="fade-up"
      >
        <h2>Our Core Services</h2>
        <p>Comprehensive pre-IPO investment solutions tailored to your needs</p>
      </div>
      {/* End Section Title */}

      <div class="container">

        <div class="row g-5">

          <div class="col-lg-4" 
          data-aos="fade-up" data-aos-delay="100"
          >
            <div class="service-item item-cyan position-relative">
              {/* <i class="bi bi-activity icon"></i> */}
              <i class="bi bi-graph-up-arrow icon"></i>
              <div>
                <h3>Pre-IPO Investment Access</h3>
                <p>Access carefully vetted pre-IPO opportunities across various sectors with institutional-grade due
                  diligence.</p>
                {/* <a href="#" class="read-more stretched-link">Learn More <i class="bi bi-arrow-right"></i></a> */}
              </div>
            </div>
          </div>{/* End Service Item */}

          <div class="col-lg-4" 
          data-aos="fade-up" data-aos-delay="200"
          >
            <div class="service-item item-orange position-relative">
              <i class="bi bi-people-fill icon"></i>
              <div>
                <h3>Portfolio management</h3>
                <p>Professional management of your pre-IPO investments with regular reporting and updates.</p>
                {/* <a href="#" class="read-more stretched-link">Learn More <i class="bi bi-arrow-right"></i></a> */}
              </div>
            </div>
          </div>{/* End Service Item */}

          <div class="col-lg-4" data-aos="fade-up" data-aos-delay="300">
            <div class="service-item item-teal position-relative">
              <i class="bi bi-lightbulb-fill icon"></i>
              <div>
                <h3>Advisory Services</h3>
                <p>Expert guidance on pre-IPO investment strategy, timing, and portfolio diversification.</p>
                {/* <a href="#" class="read-more stretched-link">Learn More <i class="bi bi-arrow-right"></i></a> */}
              </div>
            </div>
          </div>{/* End Service Item */}


        </div>
        <div class="row g-5">
          <div class="col-lg-12 center" 
          data-aos="fade-up" data-aos-delay="300"
            style={{padding: '10px !important'}}>
            <p style={{marginTop:'3%',textAlign:'center'}}>At SYM VENTURES LLP we don’t just provide Pre-IPO investment opportunities we create a seamless
              experience for our clients.</p>
          </div>
        </div>
        <div class="row g-5" data-aos="fade-up" data-aos-delay="500">
         {/* Column 1 */}
          <div class="col-md-3">
            <div class="feature-box other-services-item">              
              <h3 className="other-service-h"><i class="bi bi-graph-up"></i>&nbsp;Direct Promoters Deal</h3>
              <p>Grow your investments with our expert portfolio strategies.</p>
            </div>
          </div>

         {/* Column 2 */}
          <div class="col-md-3">
            <div class="feature-box other-services-item">
              <h3 className="other-service-h"><i class="bi bi-file-check-fill"></i>&nbsp;Exit Planning</h3>
              <p>Your transactions are safe with top-tier encryption security.</p>
            </div>
          </div>

         {/* Column 3 */}
          <div class="col-md-3">
            <div class="feature-box other-services-item">
              <h3 className="other-service-h"><i class="bi bi-search"></i>&nbsp;Research and Insights</h3>
              <p>Get insights from seasoned investment professionals.</p>
            </div>
          </div>

         {/* Column 4 */}
          <div className="col-md-3">
            <div className="feature-box other-services-item">
              <h3 className="other-service-h"><i className="bi bi-headset"></i>&nbsp;End to End Support</h3>
              <p>Achieve higher ROI with our proven investment strategies.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
   {/* /Services Section */}

    </div>
  )
}

export default OurServices